module.exports = __webpack_public_path__ + "img/ic_12_arrow_down_brand.cfc147c7.svg";